import type { CSSProperties } from "react";
import { Icon, type IconName } from "./Icon";

export type StatAccent = "yellow" | "blue" | "green" | "red";

const ACCENTS: Record<StatAccent, { color: string; soft: string }> = {
  yellow: { color: "var(--ml-yellow)", soft: "var(--ml-yellow-soft)" },
  blue: { color: "var(--ml-blue)", soft: "var(--ml-blue-soft)" },
  green: { color: "var(--success)", soft: "var(--success-soft)" },
  red: { color: "var(--danger)", soft: "var(--danger-soft)" },
};

export interface StatCardProps {
  label: string;
  value: string;
  icon?: IconName;
  accent?: StatAccent;
  deltaPct?: number;
  hint?: string;
}

export function StatCard({ label, value, icon, accent = "yellow", deltaPct, hint }: StatCardProps): JSX.Element {
  const a = ACCENTS[accent];
  const style = { "--accent": a.color, "--accent-soft": a.soft } as CSSProperties;
  const hasDelta = typeof deltaPct === "number";
  const up = hasDelta && (deltaPct as number) >= 0;
  return (
    <div className="stat" style={style}>
      {icon ? (
        <div className="stat__glyph">
          <Icon name={icon} size={18} />
        </div>
      ) : null}
      <div className="stat__label">{label}</div>
      <div className="stat__value tnum">{value}</div>
      <div className="stat__foot">
        {hasDelta ? (
          <span className={`stat__delta ${up ? "stat__delta--up" : "stat__delta--down"}`}>
            <Icon name={up ? "arrow-up" : "arrow-down"} size={13} strokeWidth={2.2} />
            {up ? "+" : ""}
            {(deltaPct as number).toFixed(1)}%
          </span>
        ) : null}
        {hint ? <span className="stat__hint">{hint}</span> : null}
      </div>
    </div>
  );
}
